<template>
    <div class="add-status-container">
        <form action="" @submit.prevent="onSubmit()">
            <!-- Friendly Name -->
            <div class="form-group">
                <label class="form-label">Friendly Name<span class="required">*</span></label>
                <div class="custom-input-wrapper" :class="{ 'has-validation': isNameEntered }">
                    <b-form-input 
                        type="text" 
                        name="name" 
                        v-model="input.name" 
                        :state="null"  
                        @input="validateName" 
                        maxlength="50" 
                        placeholder="Enter Name" 
                        class="custom-form-input"
                        required>
                    </b-form-input>
                    <span v-if="isNameEntered" class="validation-icon">
                        <svg v-if="!invalid_fname_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                            <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                            <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
                <b-form-invalid-feedback v-if="isNameEntered && invalid_fname_message">{{ invalid_fname_message }}</b-form-invalid-feedback>
            </div>
            
            <!-- Monitors Selector -->
            <div class="form-group">
                <label class="form-label">Monitors <span class="required">*</span></label>
                <div class="custom-select-wrapper monitor-select" @click="toggleMonitorDropdown">
                    <span class="select-placeholder">{{ monitorSelectText }}</span>
                    <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    
                    <!-- Monitor Dropdown -->
                    <div v-if="showMonitorDropdown" class="monitor-dropdown" @click.stop>
                        <div class="monitor-search">
                            <input 
                                type="text" 
                                v-model="monitorSearchQuery" 
                                placeholder="Search monitors..."
                                class="monitor-search-input"
                                @click.stop
                            />
                        </div>
                        <div class="monitor-options">
                            <div 
                                v-for="monitor in filteredMonitors" 
                                :key="monitor.value"
                                class="monitor-option"
                                :class="{ 'selected': isMonitorSelected(monitor) }"
                                @click.stop="toggleMonitor(monitor)"
                            >
                                <input 
                                    type="checkbox" 
                                    :checked="isMonitorSelected(monitor)"
                                    class="monitor-checkbox"
                                />
                                <span>{{ monitor.text }}</span>
                                <span v-if="monitor.badge" class="monitor-badge">{{ monitor.badge }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- Selected Monitors -->
            <div v-if="selected_monitors.length > 0" class="form-group">
                <div class="selected-monitors-header">
                    <span class="selected-monitors-title">Selected Monitors</span>
                    <span class="selected-monitors-count">{{ selected_monitors.length }}</span>
                </div>
                <div class="selected-monitors-tags">
                    <span 
                        v-for="monitor in selected_monitors" 
                        :key="monitor.value"
                        class="monitor-tag"
                    >
                        {{ monitor.text }}
                        <svg @click="removeMonitor(monitor)" class="tag-remove" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5" stroke="#6B7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </div>
            </div>
                        <!-- <b-row>
                            <b-col md="3" class="font-weight-bold">
                                Enable Subscriber
                            </b-col>
                            <b-col md="4">
                                <div class="form-group">
                                    <input class="checkbox_animated" name="enablesubscriber" type="checkbox" v-model="input.enableSubscriber" />
                                </div>
                            </b-col>
                        </b-row><hr> -->
                        <!-- <b-row>
                            <b-col md="3" class="font-weight-bold">
                                Homepage url
                            </b-col>
                            <b-col md="8">
                                <div class="form-group">
                                    <b-form-input size="sm" type="text" name="homepageurl" :state="validate_url"  v-model="input.homepageurl" placeholder="Home Page Url"></b-form-input>
                                    <b-form-invalid-feedback :state="validate_url">The given URL has an invalid character</b-form-invalid-feedback>
                                    <div><small>Set up the URL for a linkable logo / status page name in the header of the Status page.</small></div>
                                </div>
                            </b-col>
                        </b-row><hr> -->
                        <!-- <b-row>
                            <b-col md="3" class="font-weight-bold">
                                Custom Domain
                            </b-col>
                            <b-col md="8">
                                <div class="form-group">
                                    <b-form-input size="sm" type="text" name="customdomain" :state="validate_domain" v-model="input.customDomain" placeholder="use your custom domain"></b-form-input>
                                    <b-form-invalid-feedback :state="validate_domain">The given Domain has an invalid character</b-form-invalid-feedback>
                                </div>
                            </b-col>
                        </b-row><hr> -->
            <!-- Password -->
            <div class="form-group">
                <label class="form-label">Password</label>
                <div class="custom-input-wrapper password-wrapper">
                    <img src="../assets/images/icons/lock-icon.svg" class="input-icon" alt="lock" />
                    <b-form-input 
                        type="password" 
                        id="statuspagepassword" 
                        name="password" 
                        maxlength="30" 
                        v-model="input.pagePassword" 
                        placeholder="Enter Password" 
                        class="custom-form-input with-icon password-input"
                    >
                    </b-form-input>
                    <img 
                        v-if="showPassword && input.pagePassword"
                        src="../assets/fonts/feather/eye.svg"
                        class="password-toggle"
                        @click="togglePassword('statuspagepassword')"
                        title="hide password"
                        alt="hide password"
                    />
                    <img 
                        v-else-if="!showPassword && input.pagePassword"
                        src="../assets/images/icons/eye-closed.svg"
                        class="password-toggle"
                        @click="togglePassword('statuspagepassword')"
                        title="show password"
                        alt="show password"
                    />
                </div>
            </div>
            
            <!-- Robots Meta Tag -->
            <div class="form-group">
                        <!-- <b-row>
                            <b-col md="3" class="font-weight-bold">
                                Google Analytics Code
                            </b-col>
                            <b-col md="8">
                                <div class="form-group">
                                    <b-form-input name="googleAnalyticsCode" v-model="input.googleAnalyticsCode" maxlength="100" placeholder="UA-xxxxxxxxx-x"></b-form-input>
                                    <small class="text-muted">It works only if you have set up a Custom Domain for status page. Please use format like UA-xxxxxxxxx-x or G-xxxxxxxxxx. We are using </small>
                                    <a href="https://developers.google.com/analytics/devguides/collection/gtagjs" target="_blank" rel="noopener noreferrer"><small>Global site tag (gtag.js) - Google Analytics" implementation.</small></a>
                                </div>
                            </b-col>
                        </b-row><hr> -->
                <label class="form-label">Robots meta tag <span class="required">*</span></label>
                <div class="custom-select-wrapper" :class="{ 'has-validation': isMetatagSelected }">
                    <svg class="select-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="10" cy="10" r="8" stroke="#3A3A3A" stroke-width="1.5"/>
                        <path d="M10 2a8 8 0 100 16" stroke="#3A3A3A" stroke-width="1.5"/>
                        <path d="M2 10h16M10 2c2.5 0 4.5 3.5 4.5 8s-2 8-4.5 8-4.5-3.5-4.5-8 2-8 4.5-8z" stroke="#3A3A3A" stroke-width="1.5"/>
                    </svg>
                    <b-form-select 
                        name="type" 
                        v-model="input.robotsMetaTag" 
                        :options="robotsMetaTag_opt" 
                        :state="null" 
                        @change="validate_metatag" 
                        class="custom-form-select with-icon"
                        required>
                    </b-form-select>
                    <span v-if="isMetatagSelected" class="validation-icon">
                        <svg v-if="!invalid_metatag_message" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9" fill="#10B981" stroke="#10B981" stroke-width="2"/>
                            <path d="M6 10L8.5 12.5L14 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="10" cy="10" r="9" fill="#EF4444" stroke="#EF4444" stroke-width="2"/>
                            <path d="M12.5 7.5L7.5 12.5M7.5 7.5L12.5 12.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                    <svg class="dropdown-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 10L12 15L17 10" stroke="#3A3A3A" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <b-form-invalid-feedback v-if="isMetatagSelected && invalid_metatag_message">
                    {{ invalid_metatag_message }}
                </b-form-invalid-feedback>
            </div>
            
            <!-- Submit Button -->
            <div class="form-actions">
                <button 
                    type="submit" 
                    class="create-status-btn" 
                    :disabled="!canSubmit"
                    :class="{ 'disabled': !canSubmit }"
                >
                    {{edit_status?'Save Changes':'Create Status Page'}}
                </button>
            </div>
        </form>
    </div>
</template>


<script>
import StatusPageController from "../../services/statuspageController";
import MonitorsController from "../../services/monitorController";
import Multiselect from 'vue-multiselect'
import { statusPageEvents } from "../plugins/posthog-events";
export default{
    name : "AddStatus",
    components:{Multiselect},
    props:{add_status_modal:Boolean,edit_status:Boolean,status_data:{type:Object}},
    data(){
        return {
            showPassword:false,
            selected_monitors:[],
            monitor_opt:[],
            all_monitors:[],
            input:{robotsMetaTag:null,name:'',homepageurl:'',customDomain:''},
            robotsMetaTag_opt:[
              { value: null, text:'Please Select' },
              { value: 'index', text:'Index' },
              { value: 'noindex', text:'NoIndex' }
            ],
            invalid_fname_message: 'The name field is required',
            isNameEntered: false,
            isMetatagSelected: false,
            invalid_metatag_message: 'Please select a robots meta tag',
            isMonitorInvalid: false,
            isMonitorValid: false,
            invalid_monitor_message: 'Please select at least one monitor',
            showMonitorDropdown: false,
            monitorSearchQuery: ''
        }
    },
    computed:{
        validate_url(){
            return this.validateUrl(this.input.homepageurl)
        },
        validate_domain(){
            return this.validateDomain(this.input.customDomain)
        },
        showAdditionalFields(){
            return this.input.name.trim() !== '' && this.selected_monitors.length > 0;
        },
        canSubmit(){
            // Check if friendly name is valid
            const isNameValid = this.input.name && this.input.name.trim() !== '' && !this.invalid_fname_message;
            
            // Check if at least one monitor is selected
            const isMonitorValid = this.selected_monitors.length > 0;
            
            // Check if robots meta tag is selected (not null and not the placeholder option)
            const isRobotsTagValid = this.input.robotsMetaTag !== null && this.input.robotsMetaTag !== undefined;
            
            return isNameValid && isMonitorValid && isRobotsTagValid;
        },
        monitorSelectText(){
            if(this.selected_monitors.length === 0) {
                return 'Search and Add';
            }
            return `${this.selected_monitors.length} monitor${this.selected_monitors.length > 1 ? 's' : ''} selected`;
        },
        filteredMonitors(){
            if(!this.monitorSearchQuery) {
                return this.monitor_opt;
            }
            return this.monitor_opt.filter(monitor => 
                monitor.text.toLowerCase().includes(this.monitorSearchQuery.toLowerCase()) ||
                (monitor.badge && monitor.badge.toLowerCase().includes(this.monitorSearchQuery.toLowerCase()))
            );
        }
    },
    mounted(){
        this.getMonitors();
        if(this.edit_status){
            this.invalid_fname_message = '';
            this.isNameEntered = true;
            this.isMetatagSelected = true;
            this.invalid_metatag_message = '';

            this.input = this.status_data
        }
        // Close dropdown when clicking outside
        document.addEventListener('click', this.closeDropdownOnClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdownOnClickOutside);
    },
    methods:{
        async getMonitors() {
        let response = await MonitorsController.getMonitors();
        if (response.result) {
            response.data.map((t) => {
                let typeBadge = '';
                switch (t.type) {
                    case 1:
                        typeBadge = 'HTTP(s)';
                        break;
                    case 2:
                        typeBadge = 'Keyword';
                        break;
                    case 3:
                        typeBadge = 'Ping';
                        break;
                    case 4:
                        typeBadge = 'Port';
                        break;
                    case 5:
                        typeBadge = 'Heartbeat';
                        break;
                    case 6:
                        typeBadge = 'Page Speed';
                        break;
                    case 7:
                        typeBadge = 'Page Screenshot';
                        break;
                    default:
                        typeBadge = '';
                }

                this.monitor_opt.push({ value: t._id, text: t.name, type: t.type, isDown: t.isDown, badge: typeBadge });
                this.all_monitors.push({ value: t._id, text: t.name, type: t.type, isDown: t.isDown, badge: typeBadge });
            });
        }
        if(this.edit_status){

            this.input.monitors.map((m)=>{
                for(var i=0;i<this.monitor_opt.length;i++){
                    if(this.monitor_opt[i]['value']== m){
                        this.selected_monitors.push(this.monitor_opt[i])
                    }
                }
            })
        }
        },
        addTag (newTag) {
        const tag = {
            name: newTag,
            code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
        }
        this.options.push(tag)
        this.value.push(tag)
        this.validateSelectedMonitors()
        },
        validateSelectedMonitors() {
            if (!this.selected_monitors || this.selected_monitors.length == 0) {
            this.isMonitorInvalid = true;
            this.isMonitorValid = false;
            this.invalid_monitor_message = 'Please select at least one monitor';
            } else {
            this.isMonitorInvalid = false;
            this.isMonitorValid = true;
            this.invalid_monitor_message = '';
            }
        },
       async onSubmit(){
        // The canSubmit computed property already validates everything
        // So we can proceed directly with submission
        let monitors = []
        this.selected_monitors.map((t)=>{ monitors.push(t.value)})
        
        this.input.monitors = monitors

        var response
        if(this.edit_status){
            var p = { "spid": this.input._id, "changePayload":this.input }
            response= await StatusPageController.updateStatusPage(p)

            // Track status page customization in PostHog
            if(response.result){
              statusPageEvents.customized(this.input._id, 'general_update');
            }
        }
        else{
            response= await StatusPageController.addStatusPage(this.input)

            // Track status page creation in PostHog
            if(response.result && response.data && response.data._id){
              statusPageEvents.created(this.input.name);
              // Also track as published since new pages are published by default
              statusPageEvents.published(response.data._id);
            }
        }
        if(response.result){
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'success', duration: 2000});
            this.$emit('statusmodal')
        }
        else{
            this.$toasted.show(response.message, {theme: 'outline',position: "bottom-center", type: 'error', duration: 2000});
        }
        },
        validateUrl(str) {
            if (!str) {
                return false;
            }
            try {
                const url = new URL(str);
                return url.protocol === 'http:' || url.protocol === 'https:';
            } catch (error) {
                return false;
            }
        },
        validateDomain(domain){
            var regexp = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;
            if (regexp.test(domain)){ return true; }
            else{ return false; }
        },
        togglePassword(id){
          const password = document.getElementById(id);
          this.showPassword = this.showPassword === false ? true: false
          const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
          password.setAttribute('type', type);
        },
        validateName(name){
            this.isNameEntered = true;
            name = name ? name : this.input.name

            if (!name || name.trim() === '') {
                this.invalid_fname_message = 'The name field is required';
                return false;
            }

            let regexp = /^(?!\s*$)[a-zA-Z0-9 ._-]+$/;
            if (regexp.test(name)) {
                this.invalid_fname_message = '';
                return true;
            } 
            else{ 
                this.invalid_fname_message = 'Please enter valid friendly name';
                return false; 
            }
        },
        validate_metatag(){
            this.isMetatagSelected = true;
            if(!this.input.robotsMetaTag){
                this.invalid_metatag_message = 'Please select a robots meta tag';
            }
            else{
                this.invalid_metatag_message = '';
            }
        },
        toggleMonitorDropdown() {
            this.showMonitorDropdown = !this.showMonitorDropdown;
            if(this.showMonitorDropdown) {
                this.monitorSearchQuery = '';
            }
        },
        closeDropdownOnClickOutside(event) {
            if (!event.target.closest('.monitor-select')) {
                this.showMonitorDropdown = false;
            }
        },
        isMonitorSelected(monitor) {
            return this.selected_monitors.some(m => m.value === monitor.value);
        },
        toggleMonitor(monitor) {
            const index = this.selected_monitors.findIndex(m => m.value === monitor.value);
            if(index > -1) {
                this.selected_monitors.splice(index, 1);
            } else {
                this.selected_monitors.push(monitor);
            }
            this.validateSelectedMonitors();
        },
        removeMonitor(monitor) {
            const index = this.selected_monitors.findIndex(m => m.value === monitor.value);
            if(index > -1) {
                this.selected_monitors.splice(index, 1);
            }
            this.validateSelectedMonitors();
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.add-status-container {
  width: 100%;
}

/* Form Group */
.form-group {
  margin-bottom: 30px !important;
}

.form-label {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #3A3A3A;
  margin-bottom: 10px;
  margin-top: 8px;
  display: block;
}

.required {
  color: #E70000;
  margin-left: 2px;
}

/* Custom Select Wrapper */
.custom-select-wrapper {
  position: relative;
  background: transparent;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 0 12px;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.custom-select-wrapper:hover {
  border-color: #B3D1F8;
}

/* Disabled select wrapper */
.custom-select-wrapper:has(.custom-form-select:disabled) {
  background: #F3F4F6;
  cursor: not-allowed;
}

.custom-select-wrapper:has(.custom-form-select:disabled):hover {
  border-color: #D2E3FB;
}

.monitor-select {
  cursor: pointer;
}

.select-placeholder {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  color: #3A3A3A;
  opacity: 0.6;
  flex: 1;
}

.select-icon {
  width: 20px;
  height: 20px;
  opacity: 0.8;
}

.custom-form-select {
  border: none !important;
  background: transparent !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 0.915em;
  color: #3A3A3A;
  padding: 0 0 0 10px !important;
  height: auto;
  flex: 1;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.custom-form-select.with-icon {
  padding-left: 15px !important;
}

.custom-form-select:focus {
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
  border: none !important;
}

.custom-form-select option {
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
}

.dropdown-arrow {
  position: absolute;
  right: 16px;
  pointer-events: none;
  transition: transform 0.2s ease;
  z-index: 1;
}

/* Monitor Dropdown */
.monitor-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: #FFFFFF;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  max-height: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.monitor-search {
  padding: 12px;
  border-bottom: 1px solid #E5E7EB;
}

.monitor-search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #D2E3FB;
  border-radius: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  outline: none;
}

.monitor-search-input:focus {
  border-color: #3B82F6;
}

.monitor-options {
  overflow-y: auto;
  max-height: 240px;
}

.monitor-option {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  gap: 12px;
}

.monitor-option:hover {
  background-color: #F9FAFB;
}

.monitor-option.selected {
  background-color: #F3F4F6;
}

.monitor-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.monitor-badge {
  margin-left: auto;
  font-size: 12px;
  padding: 2px 8px 2px 20px;
  background-color: #E5E7EB;
  color: #6B7280;
  border-radius: 4px;
  position: relative;
}

.monitor-badge::before {
  content: '';
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background-color: #6B7280;
  border-radius: 50%;
}

/* Selected Monitors Section */
.selected-monitors-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0px 12px 0px;
}

.selected-monitors-title {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #3A3A3A;
}

.selected-monitors-count {
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #3A3A3A;
}

.selected-monitors-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.monitor-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 12px 2px 24px;
  background: rgba(41, 51, 64, 0.15);
  border-radius: 20px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #3A3A3A;
  position: relative;
}

.monitor-tag::before {
  content: '';
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 6px;
  height: 6px;
  background-color: #6B7280;
  border-radius: 50%;
}

.tag-remove {
  cursor: pointer;
  transition: transform 0.2s ease;
}

.tag-remove:hover {
  transform: scale(1.1);
}

/* Custom Input Wrapper */
.custom-input-wrapper {
  background: transparent;
  border: 1px solid #D2E3FB;
  border-radius: 12px;
  padding: 0 12px;
  height: 48px;
  display: flex;
  align-items: center;
  position: relative;
}

.custom-input-wrapper.password-wrapper {
  padding-left: 44px;
  padding-right: 50px;
}

.custom-input-wrapper.has-validation {
  padding-right: 40px;
}

/* Disabled input wrapper */
.custom-input-wrapper:has(.custom-form-input:disabled) {
  background: #F3F4F6;
}

/* Input Icons */
.input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.6;
}

/* Password Toggle */
.password-toggle {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 20px;
  height: 20px;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.password-toggle:hover {
  opacity: 1;
}

.custom-form-input {
  border: none !important;
  background: transparent !important;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #3A3A3A;
  padding: 0 !important;
  height: auto;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.custom-form-input.with-icon {
  padding-left: 15px !important;
}

.custom-form-input:focus {
  box-shadow: none !important;
  outline: none !important;
  background: transparent !important;
  border: none !important;
}

.custom-form-input::placeholder {
  color: #3A3A3A;
  opacity: 0.5;
}

.password-input {
  padding-right: 40px !important;
}

/* Validation Icon */
.validation-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.validation-icon svg {
  width: 20px;
  height: 20px;
}

/* Select validation icon */
.custom-select-wrapper.has-validation {
  padding-right: 60px;
}

.custom-select-wrapper .validation-icon {
  right: 50px;
}

/* Form Actions */
.form-actions {
  display: flex;
  justify-content: center;
  padding-top: 0;
  margin-top: 40px;
}

/* Create Status Button */
.create-status-btn {
  background: #2FB234;
  border: none;
  border-radius: 12px;
  padding: 12px 40px;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  height: 48px;
}

.create-status-btn:hover:not(:disabled) {
  background: #28A02D;
  transform: translateY(-1px);
}

.create-status-btn.disabled,
.create-status-btn:disabled {
  background: #7D8699;
  cursor: not-allowed;
  opacity: 1;
  transform: none;
}

/* Invalid Feedback */
.invalid-feedback {
  display: none;
}

.invalid-feedback.d-block {
  display: block !important;
  color: #EF4444;
  font-size: 14px;
  margin-top: 6px;
}

/* Badge Styling */
.badge-gray {
  background-color: #E5E7EB;
  color: #6B7280;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .create-status-btn {
    width: 100%;
  }
}
</style>